<template>
  <div>
    <h1>{{hgTitleName}}</h1>
    <hr>
  </div>
</template>

<script>
export default {
  props: {
    hgTitleName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/vars/theme';

hr {
  border: solid 2px $theme-color-primary;
  margin-bottom: 30px;
  margin-top: 20px;
  width: 100%;
}

h1 {
  text-transform: uppercase;
}
</style>
